import { logger } from '../logger';
import { ErrorCode } from '../types';

const log = logger.sub("DhlRestClient");

export class DhlRestClient {
    private readonly baseUrl: string | undefined;
    private readonly headers: any;

    constructor(baseUrl?: string, token?: string) {
        this.baseUrl = baseUrl;
        this.headers = {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "Authorization": "Bearer " + token,
        };
    }

    public async sendShipmentQuery(parcelId: string, cubeId: string): Promise<DhlApiResponse> {
        const requestURL = `${this.baseUrl}/api/parcel-locker/dhl-v1/shipment-query/${cubeId}?parcelId=${parcelId}`;
        log.info(`Sending Get to ${requestURL}`);
        const response = await window.fetch(requestURL, {
            headers: this.headers,
            method: 'GET',
        });
        const responseJson = await response.json() as KepServiceResponse;
        log.info(`Received response to POST to ${requestURL}: ${JSON.stringify(responseJson)}`);
        return { ok: response.ok , body: responseJson };
    }
}

export interface DhlApiResponse {
    ok: boolean;
    body: KepServiceResponse;
}

export interface KepServiceResponse {
    success: boolean;
    errorCode?: ErrorCode;
    size?: string;
    shipmentId?: string;
}

export class KepServiceError extends Error {
    public body: KepServiceResponse | undefined;

    constructor(message: string) {
        super(message);
    }

}